import React from 'react';

const AuthShell = ({ children }) => (
  <div className="auth-shell d-flex align-items-center justify-content-center min-vh-100">
    <div className="auth-glass rounded-5 shadow-lg p-4 p-md-5 w-100" style={{ maxWidth: '520px' }}>
      <div className="text-center mb-4">
        <div className="auth-brand-icon rounded-circle shadow-sm mx-auto mb-3">TM</div>
        <h1 className="h3 fw-semibold mb-1">ToivoTek Master Control</h1>
        <p className="text-muted mb-0">Secure admin access for SLP operations</p>
      </div>
      {children}
    </div>
  </div>
);

export default AuthShell;
